import { createSlice } from '@reduxjs/toolkit';
import { rtkApi } from '../../../RTK/api/rtkApi';
import { IWorkItem } from 'src/Common/manageViews/interfaces/WorkItem';

export interface IPreviewDataState {
  allDataList: IWorkItem | null;
}

const initialState = {
  allDataList: null,
} as IPreviewDataState;

const getAllDataSlice = createSlice({
  name: 'getAllData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(rtkApi.endpoints.getAllDataGrid.matchFulfilled, (state, action) => {
      state.allDataList = action.payload;
    });
  },
});

export default getAllDataSlice.reducer;
